import React, { Component } from 'react';
import { Box, Link, Typography } from '@mui/material';
import Bodycontent from './bodycontent';

class Body extends Component {
    
    render() {
        return (
            <Box
               
            >
                <Box
                    
                >
                    <Typography>
                        <Bodycontent/>       
                    </Typography>
                </Box>
            </Box>
        );
    }
}
export default Body;